export const ACTIONS = {
    HANDLE_INPUT_CHANGE: 'handleInputChange',
    HANDLE_CHECKBOX_CHANGE: 'handleCheckboxChange',
    LOADING: 'loading',
    ERROR: 'error',
    PASSWORD_TYPE: 'passwordType',
    SELECT_PHONE: 'selectPhone',
    // cart actions
    REMOVE_ITEM:"REMOVE_ITEM",
    REMOVE_ALL:"REMOVE_ALL",
    TOTAL_CARD:"TOTAL_CARD",
    ADD_ITEM:"ADD_ITEM",
    LIKE_ITEM:"LIKE_ITEM",
    UN_LIKE_ITEM:"UN_LIKE_ITEM",
}